import { combineReducers } from 'redux';
import { robotDetailsReducer } from './reducers/robotDetailsReducer';
import { robotConnectionsReducer } from './reducers/robotConnectionReducer';
import { botDetailsReducer } from './reducers/botDetailsReducer';
import { missionReducer } from './reducers/missionReducer';
import { allCoinBalanceReducer } from './reducers/allCoinBalanceReducer';
import { themeReducer } from './reducers/themeReducre';
import { soundReducer } from './reducers/soundReducer';
import { checkPointReducer } from './reducers/checkPointReducer';
import { totalDriveTimeReducer } from './reducers/totalDriveTimeReducer';
import { buyTcReducer } from './reducers/buyTcReducer';
import { hideMenuReducer } from './reducers/hideMenuReducer';
import { coinReducer } from './reducers/coinReducer';
import { missionAlphaReducer } from './reducers/missionAlphaReducer';
import { loadingSpinnerReducer } from './reducers/loadingSpinnerReducer';
import { mintingReducer } from './reducers/mintingReducer';
import { paymentReducer } from './reducers/paymentReducer';
import { checkRegister } from './reducers/checkRegister';
import { setUserDetailsReducer } from './reducers/setUserDetailsReducer';
import { mainScreenReducer } from './reducers/mainScreenReducer';
import { strpiePaymentReducer } from './reducers/strpiePaymentReducer';
import { gameRobotReducer } from './reducers/gameRobotReducer';
import { testDriveReducer } from './reducers/testDriveReducer';
import { keyBindingsReducer } from './reducers/keyBindingsReducer';
import { penaltyReducer } from './reducers/penaltyReducer';
import { aiController } from './reducers/aiController';

import appConnectionsSlice from './slices/appConnectionsSlice';
import appUserSlice from './slices/appUserSlice';
import appOwnerBotsSlice from './slices/appOwnerBotsSlice';
import appModeSlice from './slices/appModeSlice';

const rootReducer = (state, action) => {
	if (action.type === 'user/logout') {
		state = undefined;
	}

	return appReducer(state, action);
};

const appReducer = combineReducers({
	aiController: aiController,
	robotDetails: robotDetailsReducer,
	robotConnection: robotConnectionsReducer,
	botDetail: botDetailsReducer,
	missionDetail: missionReducer,
	allCoinBalance: allCoinBalanceReducer,
	activeTheme: themeReducer,
	sound: soundReducer,
	checkPointAchieve: checkPointReducer,
	totalDriveTime: totalDriveTimeReducer,
	buyTc: buyTcReducer,
	hideMenu: hideMenuReducer,
	coinName: coinReducer,
	missionAlpha: missionAlphaReducer,
	loadingSpinner: loadingSpinnerReducer,
	minting: mintingReducer,
	payment: paymentReducer,
	checkRegister: checkRegister,
	setUserDetails: setUserDetailsReducer,
	mainScreen: mainScreenReducer,
	strpie: strpiePaymentReducer,
	tournament: gameRobotReducer,
	testDriveDetails: testDriveReducer,
	keyBindings: keyBindingsReducer,
	penalty: penaltyReducer,

	// all redux toolkit slices
	appOwnerBots: appOwnerBotsSlice,
	appConnections: appConnectionsSlice,
	appUser: appUserSlice,
	appMode: appModeSlice
});

export default rootReducer;
